import { render } from "./RiskAssessment.vue?vue&type=template&id=a868e9c8&ts=true"
import script from "./RiskAssessment.vue?vue&type=script&lang=ts"
export * from "./RiskAssessment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__